var _path, _ellipse, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1223 7.74424C25.5098 5.49424 23.2536 3.76612 20.6505 2.81299C17.9848 1.83799 14.9973 1.74112 12.2661 2.51612C9.63483 3.26612 7.24108 4.82237 5.50046 6.93487C3.69733 9.11924 2.60983 11.8099 2.39733 14.6349C2.18483 17.4474 2.86921 20.3067 4.33483 22.7161C5.75046 25.0411 7.86921 26.938 10.3505 28.0599C12.9755 29.2442 15.9255 29.5755 18.7473 29.0067C21.4411 28.463 23.9473 27.0661 25.8473 25.0849C27.763 23.0849 29.0598 20.5036 29.4755 17.7599C29.5817 17.0599 29.6411 16.3536 29.6411 15.6442V15.6411C29.638 12.8255 28.763 10.0349 27.1223 7.74424ZM21.1817 16.4349C21.113 16.4817 21.0411 16.5255 20.9692 16.5724C20.1192 17.1192 19.2692 17.6661 18.4192 18.213C17.3755 18.8849 16.3348 19.5567 15.2911 20.2286C14.9942 20.4192 14.6973 20.6099 14.4005 20.8005C14.338 20.8411 14.2786 20.8817 14.213 20.913C13.613 21.2036 12.9567 20.7911 12.888 20.1567C12.888 20.1505 12.8848 20.1442 12.8848 20.138C12.8817 20.1224 12.8817 20.1067 12.8817 20.088C12.8817 20.0786 12.8817 20.0692 12.8817 20.0567V13.4099C12.8817 12.6755 12.863 11.9411 12.8817 11.2067C12.9005 10.4536 13.7005 10.0349 14.3317 10.438C14.5848 10.6005 14.8348 10.763 15.088 10.9255C16.1036 11.5786 17.1161 12.2317 18.1317 12.8849C19.0348 13.4661 19.938 14.0474 20.8411 14.6317C21.1411 14.8255 21.4661 14.9942 21.5848 15.3567C21.7317 15.7786 21.538 16.1974 21.1817 16.4349Z",
    fill: "#453DB7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 15.9398,
    rx: 14,
    ry: 13.9398,
    fill: "#99D266"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.208 10.9614C21.032 10.9614 20.936 10.9614 20.76 10.9614L14.6 17.0949L11.72 14.2273C11.544 14.2273 11.448 14.2273 11.272 14.2273L9 16.4736C9 16.6488 9 16.7444 9 16.9196L14.376 22.2725C14.552 22.2725 14.648 22.2725 14.824 22.2725L23.464 13.6697C23.464 13.4945 23.464 13.3989 23.464 13.2236L21.208 10.9614Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green-check.23c338273c7e19a06e5f2b7d6f03e4c1.svg";
export { ForwardRef as ReactComponent };